<template>
  <div class="game-board">
      <div class="tools"></div>
      <div class="main">
        <sidebar @start="start" @over="over" />
        <div class="game">
          <matrixMask />
          <matrix :matrix="matrix" @initMatrixAtFirstClick="initMatrixAtFirstClick" />
        </div>
      </div>
      <div class="info">
      </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import matrix from './matrix'
import sidebar from './sidebar'
import matrixMask from './utils/mask'
//
import { initMatrixSquare, initMatrixMine, initMatrixMineNumber } from '../utils'
import { getLevel } from '../utils/play'
import { level } from '../const'

export default {
  name: 'Board',
  data () {
    return {
      matrixSquare: null,
      customLevel: null,
      matrix: null
    }
  },
  watch: {
    // 切换难度以后要重置状态和矩阵
    storeLevel: {
      handler (level) {
        // reset state
        this.$store.dispatch('resetState')
        this.initMatrix(level)
      }
    }
  },
  computed: {
    ...mapState(['firstClickSquare']),
    storeLevel () {
      return this.$store.state.level
    }
  },
  mounted () {
    // 初始化游戏矩阵
    this.initMatrix(this.storeLevel)
  },
  methods: {
    initMatrix (customLevel) {
      customLevel = this.customLevel = level[getLevel(customLevel)]
      // static temp
      // const isOpenExtends = true
      // 初始化矩阵
      let matrixSquare = this.matrixSquare = initMatrixSquare(customLevel)
      // 保存矩阵阵列可翻开的总数量（排除了地雷的全部区块）,该数量将用于判定输赢
      // this.$store.dispatch('setTotalCount', matrixSquare.row * matrixSquare.col - customLevel.mine)
      this.$store.dispatch('setTotalCount', { matrixSquare: matrixSquare, level: customLevel })
      // 初始化地雷
      // matrixSquare = initMatrixMine(matrixSquare, customLevel, isOpenExtends)
      // 初始化数值（地雷周围的数字）
      // initMatrixMineNumber(matrixSquare.matrix)
      // 启动矩阵
      this.matrix = matrixSquare.matrix
    },
    initMatrixAtFirstClick () {
       // 初始化地雷
      this.matrixSquare = initMatrixMine(this.matrixSquare, this.customLevel, this.firstClickSquare, true)
      // 初始化数值（地雷周围的数字）
      initMatrixMineNumber(this.matrixSquare.matrix)
      // 启动矩阵
      this.matrix = this.matrixSquare.matrix
    },
    start () {
      // reset state
      this.$store.dispatch('resetState')
      // set the play state
      this.$store.dispatch('setPlayState', true)
      // init matrix
      this.initMatrix(this.storeLevel)
    },
    over () {
       // reset state
      this.$store.dispatch('resetState')
      this.$store.dispatch('setPlayState', false)
      this.initMatrix(this.storeLevel)
    }
  },
  components: {
    matrixMask,
    matrix,
    sidebar,
  }
}
</script>
<style lang="scss" scoped>

.game-board {
  display: flex;
  flex-direction: column;
  user-select: none;

  .tools {

  }

  .main {
    display: inherit;
    
    .game {
      position: relative;
      margin-left: 15px;
    }
  }

  .info {

  }
  
}
</style>